import React, { Component } from 'react';
import { saveAs } from 'file-saver';
import * as Azure from "@azure/storage-blob";
import gql from "graphql-tag";

import {
    DefaultButton,
    PrimaryButton,
    Stack,
    TextField,
    Checkbox,
    Label
} from "office-ui-fabric-react";
import { MyContext } from '../../../context';


class BotOnboardingConfig extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            botAppId1 : "",
            botAppName1 : "",
            botDisplayName1 : "",
            botAppId2 : "", 
            botAppName2 : "",
            botDisplayName2: "",
            botPolicyName: "",
            botPolicyDesc: "",
            compliancePolicy: false,
            botMeetingJoin: false,
            botMeetingKeep: false,
            botCallJoin: false,
            botCallKeep: false,
            botGroupId: ""
        };
    }

    render() {

        return (
            <Stack vertical>
                <Label><h4><MyContext.Consumer>{(context) => (<>{context.getTranslation("tenants", "createOnboardingScript")}</>)}</MyContext.Consumer></h4></Label>
                <hr />
                <Stack.Item>
                    <Checkbox
                        label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("tenants", "botCompliancePolicy")}</>)}</MyContext.Consumer>}
                        checked={this.state.compliancePolicy}
                        onChange={(event, newValue) => {
                            newValue === false ?
                                this.setState({ compliancePolicy: newValue, botAppId2: "", botAppName2: "", botDisplayName2: "", botMeetingJoin: false, botMeetingKeep: false, botCallJoin: false, botCallKeep: true }) :
                                this.setState({ compliancePolicy: newValue, botMeetingJoin: true, botMeetingKeep: true, botCallJoin: true, botCallKeep: true })
                            }
                        }
                    />
                </Stack.Item>
                <Stack.Item>
                    <TextField label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("tenants", "botPolicyName")}</>)}</MyContext.Consumer>}
                        value={this.state.botPolicyName} onChange={(event) => { this.setState({ botPolicyName: event.target.value }) }}
                    />
                </Stack.Item>
                <Stack.Item>
                    <TextField label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("tenants", "botPolicyDesc")}</>)}</MyContext.Consumer>}
                        value={this.state.botPolicyDesc} onChange={(event) => { this.setState({ botPolicyDesc: event.target.value }) }}
                    />
                </Stack.Item>
                <Stack.Item>
                    <TextField label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("tenants", "botGroupId")}</>)}</MyContext.Consumer>}
                        value={this.state.botGroupId} onChange={(event) => { this.setState({ botGroupId: event.target.value }) }}
                    />
                </Stack.Item>
                <Stack.Item>
                    <TextField label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("tenants", "botAppId1")}</>)}</MyContext.Consumer>}
                        value={this.state.botAppId1} onChange={(event) => { this.setState({ botAppId1: event.target.value }) }}                 
                    />
                </Stack.Item>
                <Stack.Item>
                    <TextField label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("tenants", "botAppName1")}</>)}</MyContext.Consumer>}
                        value={this.state.botAppName1} onChange={(event) => { this.setState({ botAppName1: event.target.value }) }}
                    />
                </Stack.Item>
                <Stack.Item>
                    <TextField label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("tenants", "botDisplayName1")}</>)}</MyContext.Consumer>}
                        value={this.state.botDisplayName1} onChange={(event) => { this.setState({ botDisplayName1: event.target.value }) }}
                            />
                </Stack.Item>
                {this.state.compliancePolicy &&
                    <Stack vertical>
                        <Stack.Item>
                            <TextField label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("tenants", "botAppId2")}</>)}</MyContext.Consumer>}
                                value={this.state.botAppId2} onChange={(event) => { this.setState({ botAppId2: event.target.value }) }}
                            />
                        </Stack.Item>
                        <Stack.Item>
                            <TextField label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("tenants", "botAppName2")}</>)}</MyContext.Consumer>}
                                value={this.state.botAppName2} onChange={(event) => { this.setState({ botAppName2: event.target.value }) }}
                            />
                        </Stack.Item>
                        <Stack.Item>
                            <TextField label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("tenants", "botDisplayName2")}</>)}</MyContext.Consumer>}
                                value={this.state.botDisplayName2} onChange={(event) => { this.setState({ botDisplayName2: event.target.value }) }}
                            />
                        </Stack.Item>
                    </Stack>
                }


                
                <br />
                <hr />
                <Stack.Item>
                    <PrimaryButton text={<MyContext.Consumer>{(context) => (<>{context.getTranslation("common", "export")}</>)}</MyContext.Consumer>}
                        disabled={(this.state.archiveBlobs && !(this.state.archiveBlobOlderThanDays > 89 && this.state.archiveBlobOlderThanDays < 99999999999)) || (this.state.convertToMP3 && !(this.state.convertBlobOlderThanDays > 0 && this.state.convertBlobOlderThanDays < 99999999999))}
                        onClick={(event) => { this.exportScript(this.props.apol); this.props.cl() }} style={{ "marginRight": "10px" }} />
                    <DefaultButton text={<MyContext.Consumer>{(context) => (<>{context.getTranslation("common", "cancel")}</>)}</MyContext.Consumer>} onClick={(event) => { this.props.cl() }} />
                </Stack.Item>
            </Stack>

        );
    }

    exportScript = async (apol) => {
        var botConfiguration = {
            botAppId1: this.state.botAppId1,
            botAppName1: this.state.botAppName1,
            botDisplayName1: this.state.botDisplayName1,
            botAppId2: this.state.botAppId2,
            botAppName2: this.state.botAppName2,
            botDisplayName2: this.state.botDisplayName2,
            botPolicyName: this.state.botPolicyName,
            botPolicyDesc: this.state.botPolicyDesc,
            botMeetingJoin: this.state.botMeetingJoin,
            botMeetingKeep: this.state.botMeetingKeep,
            botCallJoin: this.state.botCallJoin,
            botCallKeep: this.state.botCallJoin,
            botGroupId: this.state.botGroupId,
            tenantId: this.props.tenantId
        };
        console.log(botConfiguration);
        await this.props.apol
            .mutate({
                mutation: gql`
                mutation ent ($botConfiguration: BotConfigurationInputType) {
                    getBotScript (botConfiguration: $botConfiguration)
                }
                `,
                variables: { botConfiguration: botConfiguration }
            })
            .then(async result => {
                if (result.data.getBotScript !== "") {
                    var downloaded = new Blob([result.data.getBotScript], { type: "text/plain;charset=utf-8" });
                    saveAs(downloaded, "botOnboardingScript.ps1");
                }
            });
    }
}

export default BotOnboardingConfig;